import type { SVGProps } from 'react';
const SvgLandtrustPlusDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 420 57"
    fill="none"
    {...props}
  >
    <g filter="url(#landtrust-plus-dark_svg__a)">
      <path
        fill="#000"
        d="M397.611 44.707a1.357 1.357 0 0 1-1.347-1.367V12.481c0-.755.603-1.367 1.347-1.367h3.893c.744 0 1.348.612 1.348 1.367V43.34c0 .755-.604 1.367-1.348 1.367zM384.364 31.24a1.357 1.357 0 0 1-1.347-1.367v-3.95c0-.755.603-1.367 1.347-1.367h30.414c.741 0 1.345.612 1.345 1.367v3.95c0 .755-.604 1.367-1.345 1.367z"
      />
    </g>
    <path
      fill="#FAD44E"
      stroke="#FAD44E"
      strokeWidth={0.92}
      d="M397.611 44.707a1.357 1.357 0 0 1-1.347-1.367V12.481c0-.755.603-1.367 1.347-1.367h3.893c.744 0 1.348.612 1.348 1.367V43.34c0 .755-.604 1.367-1.348 1.367zM384.364 31.24a1.357 1.357 0 0 1-1.347-1.367v-3.95c0-.755.603-1.367 1.347-1.367h30.414c.741 0 1.345.612 1.345 1.367v3.95c0 .755-.604 1.367-1.345 1.367z"
    />
    <path
      fill="#fff"
      d="M376.053 15.765h-9.487V49.36h-11.149V15.876h-9.56V6.608h30.196zM204.29 15.782h-9.487v33.6h-11.149V15.895h-9.56V6.633h30.196zM93.047 6.652l12.637 23.357V6.608h10.179v42.775h-10.488L92.982 25.96v23.402H82.878V6.651zM242.366 35.996l5.154 13.364h-10.781a8334 8334 0 0 0-5.254-13.389h-4.683v13.398h-10.921V6.64h4.836c7.307 0 14.616-.037 21.922.017 2.864.02 4.677 1.613 4.742 4.448q.225 10.12 0 20.244c-.052 2.927-2.075 4.29-5.015 4.648m-15.525-20.1v11.248h8.609a.912.912 0 0 0 .909-.911v-9.428a.905.905 0 0 0-.909-.91zM71.772 49.392H61.244l-1.831-9.098H48.34c-.628 2.995-1.262 6.004-1.91 9.09H36.147c3.07-14.297 6.11-28.505 9.179-42.774h17.268c3.047 14.207 6.101 28.436 9.179 42.782M57.939 30.786 55 15.744h-2.134c-1.012 4.987-2.02 9.974-3.054 15.042zM10.818 40.21H24.46v9.173H0V6.608h10.818zM282.264 6.608v32.466a.92.92 0 0 1-.268.648.9.9 0 0 1-.645.267h-7.445a.9.9 0 0 1-.645-.267.92.92 0 0 1-.267-.648V6.608h-11.025V44.94c0 2.443 1.971 4.424 4.403 4.424h22.506c2.432 0 4.404-1.982 4.404-4.426V6.608zM131.337 49.383V6.657h22.522c5.154 0 8.955 3.645 8.989 8.81q.088 12.542 0 25.086c-.046 5.18-3.85 8.824-8.999 8.824h-22.512zm11.036-33.503v24.2c2.346 0 4.623.092 6.889-.031 1.554-.084 2.589-1.274 2.6-2.912q.067-9.16 0-18.32c-.013-1.644-1.046-2.828-2.596-2.912-2.27-.123-4.549-.03-6.893-.03zM306.214 36.48c0 1.9-.115 3.747.022 5.577.31 4.136 3.799 7.47 7.924 7.539q7.022.116 14.047 0c3.879-.06 7.534-3.112 7.826-6.906.268-3.905.275-7.825.02-11.731-.176-3.002-2.574-5.277-5.55-5.806a766 766 0 0 0-13.834-2.343c-.901-.142-1.186-.527-1.176-1.342.017-1.404 0-2.807.013-4.21 0-.96.462-1.414 1.457-1.405 2.875.027 5.752.021 8.627 0 .992 0 1.425.466 1.412 1.433v2.183h9.117c0-2.078.17-4.067-.036-6.017-.406-3.818-3.896-6.992-7.718-7.057a423 423 0 0 0-14.416 0c-3.784.07-7.434 3.38-7.651 7.124a108 108 0 0 0-.01 11.375c.147 3.103 2.539 5.547 5.567 6.082q6.97 1.233 13.954 2.367c.775.127 1.058.435 1.041 1.195-.031 1.485-.01 2.971-.01 4.458 0 .857-.414 1.298-1.283 1.298h-8.875c-.859 0-1.286-.458-1.304-1.3-.017-.842 0-1.63 0-2.509z"
    />
    <defs>
      <filter
        id="landtrust-plus-dark_svg__a"
        width={35.106}
        height={35.592}
        x={382.017}
        y={11.114}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_257_2540"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_257_2540"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgLandtrustPlusDark;
